import { useEffect } from "react";

/**
 * useIdleSettle — controla el estado global "is-scrolling" / "settle-in".
 *
 * Cuando el usuario está haciendo scroll, agrega `.is-scrolling` a <html>.
 * Cuando deja de scrollear por >180ms, remueve `.is-scrolling` y agrega
 * `.settle-in` durante 900ms (ventana en la que los CTAs "asientan" con
 * un pequeño brillo de reposo). Es el "detalle que casi nadie hace" (#25).
 *
 * También agrega `.living-bg` a body para el fondo vivo global.
 */
export function useIdleSettle() {
  useEffect(() => {
    document.body.classList.add("living-bg");

    let scrollTimer = null;
    let settleTimer = null;
    const html = document.documentElement;

    const onScroll = () => {
      if (!html.classList.contains("is-scrolling")) {
        html.classList.add("is-scrolling");
        html.classList.remove("settle-in");
      }
      if (scrollTimer) window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => {
        html.classList.remove("is-scrolling");
        html.classList.add("settle-in");
        if (settleTimer) window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(() => {
          html.classList.remove("settle-in");
        }, 900);
      }, 180);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (scrollTimer) window.clearTimeout(scrollTimer);
      if (settleTimer) window.clearTimeout(settleTimer);
      html.classList.remove("is-scrolling", "settle-in");
      document.body.classList.remove("living-bg");
    };
  }, []);
}
